import _JSON$stringify from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/json/stringify";
import _typeof from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/typeof";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.replace";

/*
 * @Author: Jhonsem
 * @Date: 2019-03-19 14:18:03
 * @Last Modified by: Jhonsem
 * @Last Modified time: 2019-04-17 18:22:17
 */
import localStorageHelper from "@/localstorage/localstorage";
import { sendMapEvent } from "@/utils/analytics";
import { toString } from "lodash";
var UUID = "";
/**
 *  UUID
 */

export function creatUUid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === "x" ? r : r & 0x3 | 0x8;
    return v.toString(16);
  }).toUpperCase();
}
export function FaceUUid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx-xxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === "x" ? r : r & 0x3 | 0x8;
    return v.toString(16);
  }).toUpperCase();
}
export function filterBase64Pic(picUrl) {
  if (picUrl.includes("data:image/jpeg;base64,")) {
    //过滤data:image/jpeg;base64,
    // console.log("带有：data:image/jpeg;base64");
    var newPicUrl = picUrl.replace("data:image/jpeg;base64,", "");
    return newPicUrl;
  } else {
    return picUrl;
  }
}
export function filterBase64PicPng(picUrl) {
  if (picUrl.includes("data:image")) {
    // const newPicUrl = picUrl.replace("data:image/jpeg;base64,", "");
    var index = picUrl.indexOf(',');
    return picUrl.substring(index + 1, picUrl.length);
  } else {
    return picUrl;
  }
}
/**
 *  UUID
 */

export function getUUid() {
  if (UUID !== "") {
    return UUID;
  } else {
    if (localStorageHelper.has(localStorageHelper.key.UUID)) {
      UUID = localStorageHelper.get(localStorageHelper.key.UUID);
      return UUID;
    } else {
      UUID = creatUUid();
      return UUID;
    }
  }
}
/**
 * 获取语言
 */

export function getLang() {
  var lang = window.navigator.language || window.navigator.userLanguage; //常规浏览器语言和IE浏览器

  lang = lang.substr(0, 2); //截取lang前2位字符

  if (lang === "en" || lang === "de" || lang === "fr" || lang === "es" || lang === "it" || lang === "zh") {
    lang = lang;
  } else {
    lang = "en";
  }

  return lang;
}
/**
 * 获取国家
 */
// export function getCountry() {
//   const lang =
//     window.navigator.language || (window.navigator as any).userLanguage; //常规浏览器语言和IE浏览器
//   return lang.includes('-') ? lang.substr(3) : lang
// }

/**
 * 获取星座的时间戳
 * @param type
 */

export function getDateStr() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "today";

  switch (type) {
    case "today":
      {
        var date = new Date();
        var dateStr = ("0000" + date.getFullYear()).slice(-4);
        dateStr = dateStr + ("00" + (date.getMonth() + 1)).slice(-2);
        dateStr = dateStr + ("00" + date.getDate()).slice(-2);
        return dateStr;
      }

    case "tomorrow":
      {
        var _date = new Date();

        _date.setTime(_date.getTime() + 86400000); // 明天


        var _dateStr = ("0000" + _date.getFullYear()).slice(-4);

        _dateStr = _dateStr + ("00" + (_date.getMonth() + 1)).slice(-2);
        _dateStr = _dateStr + ("00" + _date.getDate()).slice(-2);
        return _dateStr;
      }

    case "week":
      {
        var _date2 = new Date();

        var _dateStr2 = ("0000" + _date2.getFullYear()).slice(-4);

        _dateStr2 += ("00" + (_date2.getMonth() + 1)).slice(-2);
        _dateStr2 += ("00" + _date2.getDate()).slice(-2);
        return _dateStr2;
      }

    case "month":
      {
        var _date3 = new Date();

        var _dateStr3 = ("0000" + _date3.getFullYear()).slice(-4);

        _dateStr3 += ("00" + (_date3.getMonth() + 1)).slice(-2);
        return _dateStr3;
      }

    case "year":
      {
        var _date4 = new Date();

        var _dateStr4 = ("0000" + _date4.getFullYear()).slice(-4);

        return _dateStr4;
      }

    default:
      break;
  }
}
/**
 * 请求加密
 * @param data
 */

export function faceServerEncrypt(data) {
  return new _Promise(
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(resolve, reject) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              try {
                Cordova.exec(function (encryptData) {
                  // console.info("encryptData:", encryptData);
                  resolve(encryptData);
                }, function (error) {
                  console.info("error:", error);
                  reject(error);
                }, "FaceEncrypt", "encrypt", [data]);
              } catch (error) {
                reject(error);
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
}
export var clientError = function clientError(key, result) {
  try {
    if (result.error) {
      var error_message = "";

      if (typeof result.error === "string") {
        error_message = result.error;
      } else if (_typeof(result.error) === "object") {
        error_message = _JSON$stringify(result.error);
      } else {
        error_message = toString(result.error);
      }

      sendMapEvent("face_" + key, {
        error_code: result.status ? toString(result.status) : "1003",
        error_message: error_message
      });
    } else {
      //不存在error:
      var _error_message = "";

      if (typeof result === "string") {
        _error_message = result;
      } else if (_typeof(result) === "object") {
        _error_message = _JSON$stringify(result);
      } else {
        _error_message = toString(result);
      }

      sendMapEvent("face_" + key, {
        error_code: "1004",
        error_message: _error_message
      });
    }
  } catch (error) {}
};